import Vue from 'vue';
import App from './App.vue';
import VueScrollTo from 'vue-scrollto';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
// import { detect } from 'detect-browser';
import store from './store';
import router from "./router/index.js";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCog, faCheck, faUser, faLongArrowAltRight, faLongArrowAltLeft, faThumbtack, faTrash, faTimes, faCircle, faChevronDown, faPlay, faPause, faDownload, faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import AudioRecorder from 'audio-recorder-polyfill'
import mpegEncoder from 'audio-recorder-polyfill/mpeg-encoder'
import './axios'

Vue.use(require('vue-moment'));


AudioRecorder.encoder = mpegEncoder
AudioRecorder.prototype.mimeType = 'audio/mpeg'
window.MediaRecorder = AudioRecorder

library.add(faCog, faCheck, faUser, faLongArrowAltRight, faLongArrowAltLeft, faThumbtack, faTrash, faTimes, faCircle, faChevronDown, faPlay, faPause, faDownload, faBars);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

Vue.use(BootstrapVue);

Vue.use(VueSweetalert2);

/*
// Browser Detection
axios.post(process.env.VUE_APP_BASE_URL + '/api/router/Tracking.php',{
  action: "tracking",
  prefix: "XXXX",
  label: `browser/${detect().name}`
}).catch( () => {
  window.console.log('failed tracking')
});
*/

Vue.directive('ePitchTracking', {
  bind(el, binding) {
    const label = binding.value;

    el.addEventListener('click', () => {
      // axios.post(process.env.VUE_APP_BASE_URL + '/api/router/Tracking.php',{
      //   action: "tracking",
      //   prefix: "XXXX2020",
      //   label: label
      // }).catch( () => {
      //   window.console.log('failed tracking')
      // });
      //window.console.log(label);
    });
  }
});

router.beforeEach((to, from, next) => {
  if(to.matched.some(route => route.meta.requiresAuth)){
    if(localStorage.getItem('token') == (null || undefined)){
      next('/');
    }else{
      next();
    }
  }else{
    //window.console.log('not required');
    next();
  }
})

new Vue({
  store,
  created() {
    AOS.init();
  },
  router,
  render: h => h(App)
}).$mount('#app');
